import styled from 'styled-components';
import SkeletonGameCard from '../components/sportsbook-skeleton-game-card';

const Wrapper = styled.ul`
	display: flex;
	flex-direction: column;
	container-type: inline-size;
`;

type GameCardListProps = {
	className?: string;
	children: React.ReactNode;
};

/**
 * Wrapper for list of game cards. Use it together with GameCardListHeader and GameCardListFooter.
 */
const GameCardList: React.FC<GameCardListProps> = ({ className, children }) => {
	return <Wrapper className={className}>{children}</Wrapper>;
};

export const SkeletonGameCardList: React.FC<{ itemCount?: number }> = ({ itemCount = 5 }) => {
	const items = new Array(itemCount).fill(null);
	return (
		<Wrapper>
			{items.map((_, index) => {
				// eslint-disable-next-line react/no-array-index-key
				return <SkeletonGameCard key={index} />;
			})}
		</Wrapper>
	);
};

export default GameCardList;
